const clientInfoAndNotesSection = docData => {
  const doc = docData.doc
  const job = docData.job

  const numberOfLines = str => {
    if (str) {
      return (str.match(/\n/g) || []).length
    } else {
      return 1
    }
  }

  docData.doc.setFontSize(10)

  // left half
  let leftHalfHeight = 0
  doc.setFont(undefined, 'bold')
  doc.text(job.quote.quoteTitle, 20, docData.yAxis + leftHalfHeight, { align: 'left' })
  leftHalfHeight += 1 * docData.doc.getFontSize() * 1.15
  doc.setFont(undefined, 'normal')
  doc.text('Client: ' + job.client, 20, docData.yAxis + leftHalfHeight, { align: 'left' })
  leftHalfHeight += 1 * docData.doc.getFontSize() * 1.15
  doc.text('Contact Person: ' + job.contactPerson, 20, docData.yAxis + leftHalfHeight, { align: 'left' })
  leftHalfHeight += 1 * docData.doc.getFontSize() * 1.15
  doc.text('Producer: ' + job.producer, 20, docData.yAxis + leftHalfHeight, { align: 'left' })
  leftHalfHeight += 1 * docData.doc.getFontSize() * 1.15 + docData.buffer

  doc.setFont(undefined, 'bold')
  doc.text('Notes', 20, docData.yAxis + leftHalfHeight, { align: 'left' })
  leftHalfHeight += 1 * docData.doc.getFontSize() * 1.15
  doc.setFont(undefined, 'normal')
  doc.text(job.quote.notes || '', 20, docData.yAxis + leftHalfHeight, { align: 'left' })
  leftHalfHeight += numberOfLines(job.quote.notes) * docData.doc.getFontSize() * 1.15 + docData.buffer

  // right half
  let rightHalfHeight = 0
  doc.setFont(undefined, 'bold')
  doc.text('Estimate Includes', doc.internal.pageSize.getWidth() / 2, docData.yAxis, { align: 'left' })
  rightHalfHeight += 1 * docData.doc.getFontSize() * 1.15
  doc.setFont(undefined, 'normal')
  doc.text(job.quote.estimateIncludes || '', doc.internal.pageSize.getWidth() / 2, docData.yAxis + rightHalfHeight, {
    align: 'left',
  })
  rightHalfHeight += numberOfLines(job.quote.estimateIncludes) * docData.doc.getFontSize() * 1.15 + docData.buffer

  doc.setFont(undefined, 'bold')
  doc.text('Estimate Excludes', doc.internal.pageSize.getWidth() / 2, docData.yAxis + rightHalfHeight, {
    align: 'left',
  })
  rightHalfHeight += 1 * docData.doc.getFontSize() * 1.15
  doc.setFont(undefined, 'normal')
  doc.text(job.quote.estimateExcludes || '', doc.internal.pageSize.getWidth() / 2, docData.yAxis + rightHalfHeight, {
    align: 'left',
  })
  rightHalfHeight += numberOfLines(job.quote.estimateExcludes) * docData.doc.getFontSize() * 1.15 + docData.buffer

  docData.yAxis += leftHalfHeight > rightHalfHeight ? leftHalfHeight : rightHalfHeight

  return docData
}

export default clientInfoAndNotesSection
